import { Link } from "react-router-dom";
import { heroStats } from "@/mocks/site/content";

const HERO_IMG =
  "https://readdy.ai/api/search-image?query=stylized%20warm%20editorial%20illustration%20of%20a%20cream%20colored%20moving%20truck%20parked%20on%20a%20brownstone%20brooklyn%20street%20at%20golden%20hour%20with%20two%20uniformed%20movers%20carrying%20a%20wrapped%20sofa%20and%20stacked%20cardboard%20boxes%20artistic%20muted%20earth%20tones%20with%20deep%20burnt%20orange%20accents%20painterly%20texture%20cinematic%20wide%20composition%20professional%20moving%20company%20aesthetic%20with%20strong%20directional%20warm%20sunset%20light%20and%20long%20soft%20shadows&width=1800&height=1200&seq=site-hero-main&orientation=landscape";

export default function Hero() {
  return (
    <section className="relative min-h-[760px] md:min-h-[860px] flex items-end overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img src={HERO_IMG} alt="Haulmark moving truck and crew at golden hour" className="w-full h-full object-cover object-top" />
        <div className="absolute inset-0 bg-gradient-to-b from-ink-900/55 via-ink-900/35 to-ink-900/85"></div>
      </div>

      <div className="relative w-full max-w-7xl mx-auto px-4 md:px-6 pt-32 md:pt-40 pb-12 md:pb-16">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/10 backdrop-blur border border-white/20 text-white text-xs font-semibold mb-6">
            <span className="w-1.5 h-1.5 rounded-full bg-brand-400 animate-pulse"></span>
            <span>Booking June – August 2026 now</span>
          </div>

          <h1 className="font-display text-white text-4xl md:text-6xl lg:text-7xl font-bold leading-[1.05] tracking-tight mb-6">
            Moving day,
            <br />
            <span className="text-brand-300">finally feels easy.</span>
          </h1>

          <p className="text-base md:text-lg text-white/85 leading-relaxed max-w-xl mb-8">
            Flat-rate pricing, background-checked crews, and an on-time guarantee that actually pays out. Family-owned and serving the tri-state area since 2007.
          </p>

          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 mb-12">
            <Link
              to="/site/contact"
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md text-sm font-semibold bg-brand-500 hover:bg-brand-600 text-white cursor-pointer whitespace-nowrap transition-colors"
            >
              Get a Free Quote
              <i className="ri-arrow-right-line"></i>
            </Link>
            <a
              href="tel:+13475550142"
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md text-sm font-semibold bg-white/10 hover:bg-white/15 backdrop-blur border border-white/20 text-white cursor-pointer whitespace-nowrap transition-colors"
            >
              <i className="ri-phone-line"></i>
              (347) 555-0142
            </a>
          </div>

          {/* Stat strip */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 pt-8 border-t border-white/15 max-w-2xl">
            {heroStats.map((s) => (
              <div key={s.label}>
                <div className="font-display text-2xl md:text-3xl font-bold text-white leading-none mb-1.5">
                  {s.value}
                </div>
                <div className="text-[11px] uppercase tracking-[0.15em] text-white/65 font-semibold">
                  {s.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

    </section>
  );
}